/**
 * QuotationLineApprovalStatusService
 * Service for QuotationLineApprovalStatus lookup operations
 * Route: api/quotationlineapprovalstatus
 * Controller: QuotationLineApprovalStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * QuotationLineApprovalStatusService
 * Handles quotation line approval status CRUD operations
 * Maps to /api/quotationlineapprovalstatus endpoint
 */
export class QuotationLineApprovalStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? QuotationLineApprovalStatusService.DEFAULT_SERVICE_PATH,
            basePath: QuotationLineApprovalStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
QuotationLineApprovalStatusService.DEFAULT_SERVICE_PATH = 'procurements';
QuotationLineApprovalStatusService.BASE_PATH = 'api/quotationlineapprovalstatus';
//# sourceMappingURL=QuotationLineApprovalStatusService.js.map